import { Navigate } from "react-router-dom";
import { useContext, useEffect } from "react";
import { UserContext } from "../../contexts/user.context";

const AdminGuard = ({ children, requiredRole }) => {
  const { user, isAdmin, userRole } = useContext(UserContext);
   
  useEffect(()=>{
        document.title = "Admin Dashboard";
  },[])

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!isAdmin) {
    return <Navigate to="/dashboard/property-list" replace />;
  }

  if (requiredRole && userRole !== requiredRole) {
    return <Navigate to="/dashboard/admin" replace />;
  }



  return children;
};

export default AdminGuard;